import { FormEvent, ReactNode, useState } from "react";
import { FormEncType, useParams } from "react-router-dom";
import "./feedbackForm.css";
import { FormQuestion, TableOptions } from "../types";
import { Typography } from "@mui/material";

function FeedbackForm(props: {
  questions: {
    [key: string]: FormQuestion;
  };
  answers: {
    [key: string]: {
      [key: string]: string;
    };
  };
  userAnswers: {
    [key: string]: string;
  };
  tableId: string;
  tableOptions: TableOptions;
  color: string;
}) {
  let answerTable = null;
  if (props.answers) {
    let tbody = [];
    let headers = [<th key="feedbackanswerstopleft"></th>];
    let questions: {
      [key: string]: {
        // questionId
        [key: string]: // username
        string; // answer text
      };
    } = {};

    for (let username in props.answers) {
      headers.push(<th key={"feedbackusername_" + username}>{username}</th>);
      for (let questionId in props.answers[username]) {
        if (!questions[questionId]) {
          questions[questionId] = {};
        }
        questions[questionId][username] = props.answers[username][questionId];
      }
    }

    for (let questionId in questions) {
      let row = [];
      row.push(<th key={"feedbackquestionheader_" + questionId}>{questionId}</th>);
      let userAnswers = questions[questionId];
      for (let username in userAnswers) {
        row.push(<td key={"feedbackanswer_" + questionId + "_" + username}>{userAnswers[username]}</td>);
      }
      tbody.push(<tr key={"feedbackrow_" + questionId}>{row}</tr>);
    }

    let header = <tr>{headers}</tr>;
    answerTable = (
      <table className="feedback-table" border={1}>
        <thead>{header}</thead>
        <tbody>{tbody}</tbody>
      </table>
    );
  }

  let questions = [] as ReactNode[];
  const [submitted, setSubmitted] = useState(false);

  let formQuestions = [] as { questionId: string; question: FormQuestion }[];

  for (let questionId in props.questions ?? []) {
    let question = props.questions[questionId];
    if (question.condition) {
      let legit = true;
      for (let option in question.condition) {
        if (props.tableOptions[option] !== question.condition[option]) {
          legit = false;
        }
      }
      if (!legit) {
        continue;
      }
    }
    formQuestions.push({ questionId, question });
  }

  questions = formQuestions
    .sort((a, b) => (a.question.formOrder ?? 0) - (b.question.formOrder ?? 0))
    .map((tuple) => {
      let input = <input type={tuple.question.type} name={tuple.questionId}></input>;
      let storageId = "feedback-" + props.tableId + "-" + tuple.questionId;
      let isUnsent =
        localStorage.getItem(storageId) && localStorage.getItem(storageId) !== props.userAnswers?.[tuple.questionId];
      if (tuple.question.type === "textarea") {
        input = (
          <textarea
            name={tuple.questionId}
            defaultValue={
              localStorage.getItem(storageId) ?? (props.userAnswers && props.userAnswers[tuple.questionId]) ?? ""
            }
            onInput={(e) => {
              localStorage.setItem(storageId, (e.target as HTMLTextAreaElement).value);
            }}
          ></textarea>
        );
      }
      return (
        <div className="feedback-form-question" key={"q" + tuple.questionId} data-formorder={tuple.question.formOrder}>
          <Typography>{tuple.question.text}</Typography>
          <div style={{ color: isUnsent ? "red" : "inherit" }}>{isUnsent ? "You have unsent changes" : ""}</div>
          {input}
        </div>
      );
    });

  return (
    <div className="feedback-answers-form-wrapper">
      <Typography>
        It is ok to leave some fields unfilled if you have nothing new to share. You can come back to this page and
        complete the feedback form any time later. You can still edit your answers after submitting. You can find all
        your finished games in your user profile.
      </Typography>
      {answerTable ? (
        <div>
          <h2>Feedback answers:</h2>
          {answerTable}
        </div>
      ) : null}

      <form
        onSubmit={(evt: FormEvent<HTMLFormElement>) => {
          evt.preventDefault();
          let formData = new FormData(evt.currentTarget);
          let sendData: {
            [key: string]: any;
          } = {
            tableId: props.tableId,
            color: props.color,
            user: localStorage.getItem("user-name"),
            answers: {},
          };
          for (const [key, value] of formData.entries()) {
            sendData.answers[key] = value ?? "";
          }
          fetch("/api/submit-feedback", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData),
          })
            .then((res) => {
              if (res.status === 200) {
                setSubmitted(true);
                for (let tuple of formQuestions) {
                  let storageId = "feedback-" + props.tableId + "-" + tuple.questionId;
                  localStorage.removeItem(storageId);
                }
                return;
              }
              return Promise.reject(res.text());
            })
            .catch((error) => {
              console.error(error);
            });
        }}
      >
        {questions}
        <input type="submit" className="submit-button" value="Send feedback"></input>
        {submitted ? <span>Answers submitted, thanks for playing! ☺️</span> : <></>}
      </form>
    </div>
  );
}

export { FeedbackForm };
